/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowDownLeft = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M17 7 7 17" }],
    ["path", { d: "M17 17H7V7" }]
  ]
];

export { ArrowDownLeft as default };
//# sourceMappingURL=arrow-down-left.js.map
